import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/types';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-background-300/60">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="aspect-[16/10] overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </div>
        <div className="p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className="inline-block px-2 py-0.5 rounded-full text-xs bg-primary-100 text-primary-700 whitespace-nowrap">
              {article.category}
            </span>
            <span className="text-xs text-foreground-500">{article.date} · {article.readTime} 分钟阅读</span>
          </div>
          <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
            {article.title}
          </h3>
          <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {article.excerpt}
          </p>
          <div className="mt-3 flex items-center gap-2 flex-wrap">
            {article.tags.map((tag) => (
              <span key={tag} className="text-xs text-foreground-400">
                #{tag}
              </span>
            ))}
          </div>
        </div>
      </Link>
    </article>
  );
}